import stores from '../stores';
import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { version } from '../../package.json';

const API_ROOT = import.meta.env.REACT_APP_API_URL;
const appId = uuid();
const appVersion = version;
const SHOPPING_BOSS_VERSION = '5.4';

class BaseService {
    /**
     * Centralized error handler. By default a 401 response logs the user out;
     * pass `{ skipAuthHandling: true }` in a request's options to opt out
     * (e.g. for service-status / monitoring calls whose 401 says nothing
     * about the user's session validity).
     */
    handleErrors(err, options) {
        if (err && err.response && err.response.status === 401) {
            if (options && options.skipAuthHandling) return err;
            stores.authStore.logout(401);
        }
        return err;
    }


    commonHeaders() {

        let headers = {
            'X-App-Request-Id': `${appId}`,
            'X-App-Version': `${appVersion}`,
            'X-Version': SHOPPING_BOSS_VERSION

        };

        if (stores.authStore.token || stores.authStore.guestToken)
            headers['Authorization'] = `Bearer ${stores.authStore.token || stores.authStore.guestToken}`;
        return { headers };

    }


    async del(url, body, options) {
        try {
            let response = await axios.delete(url, { baseURL: API_ROOT, ...this.commonHeaders(), ...options, data: body });
            return response.data;
        }
        catch (e) {
            let notHandled = this.handleErrors(e, options);
            if (notHandled)
                throw notHandled;
        }
    }

    async get(url, params, options) {
        try {
            let response = await axios.get(url, {
                params,
                baseURL: API_ROOT, ...this.commonHeaders(), ...options
            });
            return response.data;
        }
        catch (e) {
            let notHandled = this.handleErrors(e, options);
            if (notHandled)
                throw notHandled;
        }
    }

    async put(url, body, options) {
        try {
            let config = { ...this.commonHeaders(), ...options };
            if (!url.startsWith("http://") && !url.startsWith("https://"))
                config.baseURL = API_ROOT;
            let response = await axios.put(url, body, config);
            return response.data;
        }
        catch (e) {
            let notHandled = this.handleErrors(e, options);
            if (notHandled)
                throw notHandled;
        }
    }
    async patch(url, body, options) {
        try {
            let config = { ...this.commonHeaders(), ...options };
            if (!url.startsWith("http://") && !url.startsWith("https://"))
                config.baseURL = API_ROOT;
            let response = await axios.patch(url, body, config);
            return response.data;
        }
        catch (e) {
            let notHandled = this.handleErrors(e, options);
            if (notHandled)
                throw notHandled;
        }
    }

    async post(url, body, options) {
        try {
            let config = { ...this.commonHeaders(), ...options };
            if ( ! ( url.startsWith("http://")||url.startsWith("https://")) )
                config.baseURL=API_ROOT
            let response = await axios.post(url, body, config);
            return response.data;
        }
        catch (e) {
            let notHandled = this.handleErrors(e, options);
            if (notHandled)
                throw notHandled;
        }
    }
}

export default BaseService;